import script from "./AudioStylePanel.vue?vue&type=script&lang=ts&setup=true"
export * from "./AudioStylePanel.vue?vue&type=script&lang=ts&setup=true"

import "./AudioStylePanel.vue?vue&type=style&index=0&id=1da06c97&lang=scss&scoped=true"

import exportComponent from "/opt/buildhome/repo/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-1da06c97"]])

export default __exports__